import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from 'reactstrap';
import { format as formatDate } from 'date-fns';
import { get, flatten, sortBy } from 'lodash';
import { toast } from 'react-toastify';

import useCollectionSubscription from '../hooks/useCollectionSubscription';
import ProgressButton from '../ProgressButton';
import { functions } from '../../firebase';

const pullAmazonOrder = functions.httpsCallable('pullAmazonOrder', { timeout: 550000 });

export default function FulfillmentOrdersModal(props) {
  const { order, isOpen, onClickClose } = props;

  const fulfillmentOrders = useCollectionSubscription(
    order?.ref.collection('fulfillmentOrders').orderBy('createdAt', 'desc'),
    [order?.id]
  );

  const getShipmentInfo = (fulfillmentOrder) => {
    const shipments = flatten([get(fulfillmentOrder, 'FulfillmentShipment.member', [])]).filter(_ => _);
    if (shipments.length === 0) return { shippedAt: null, carrier: null, trackingNumber: null };

    const [firstShipment] = sortBy(shipments, _ => get(_, 'ShippingDateTime'));
    return {
      shippedAt: get(firstShipment, 'ShippingDateTime'),
      carrier: get(firstShipment, 'FulfillmentShipmentPackage.member.CarrierCode'),
      trackingNumber: get(firstShipment, 'FulfillmentShipmentPackage.member.TrackingNumber'),
    };
  };

  return (
    <Modal isOpen={isOpen} size="xl">
      <ModalHeader>
        出荷指示一覧 - {order?.sourceOrderId}
      </ModalHeader>
      <ModalBody>
        {fulfillmentOrders.length > 0 ? (
          <Table bordered>
            <thead className="thead-light">
              <tr>
                <th>出荷指示ID</th>
                <th>ステータス</th>
                <th>出荷日時</th>
                <th>配送会社</th>
                <th>追跡番号</th>
                <th>作成日時</th>
                <th>最終更新</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {fulfillmentOrders.map(_ => {
                const { shippedAt, carrier, trackingNumber, amazonOrderId, } = getShipmentInfo(_);
                const onClickPullAmazonOrder = async () => {
                  try {
                    await pullAmazonOrder({ orderId: order.id, amazonOrderId: _.amazonOrderId, });
                    toast.success('最新情報を取得しました');
                  } catch(e) {
                    console.error(e);
                    toast.error('失敗しました');
                  }
                };

                return (
                  <tr key={_.id}>
                    <td>{_.amazonOrderId}</td>
                    <td>{_.amazonStatus}</td>
                    <td>{shippedAt && formatDate(new Date(shippedAt), 'yyyy/MM/dd HH:mm:ss')}</td>
                    <td>{carrier}</td>
                    <td>{trackingNumber}</td>
                    <td>{_.createdAt && formatDate(_.createdAt.toDate(), 'yyyy/MM/dd HH:mm:ss')}</td>
                    <td>{_.updatedAt && formatDate(_.updatedAt.toDate(), 'yyyy/MM/dd HH:mm:ss')}</td>
                    <td>
                      <ProgressButton
                        size="sm"
                        process={onClickPullAmazonOrder}
                      >
                        最新情報を取得
                      </ProgressButton>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        ) : (
          <div className="text-center text-muted py-4">
            出荷指示がありません
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button className="cancel" color="secondary" onClick={onClickClose}>閉じる</Button>
      </ModalFooter>
    </Modal>
  );
}
